import { createFormData } from "nhb-toolbox";
import type { UseFormReset } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import FairForm from "./FairForm";
import type { IFairCreation } from "./type/fairType";
import { useEffect } from "react";

interface Props {
	handleClose: () => void;
}

export default function CreateFair({ handleClose }: Props) {
	const {
		mutate: createFair,
		isPending,
		isSuccess,
	} = useApiMutation<FormData, void>({
		method: "POST",
		endPoint: "/api/fair",
		invalidateQueries: ["Fairs"],
	});

	const handleCreateFair = (
		data: IFairCreation,
		reset: UseFormReset<IFairCreation>
	) => {
		const formData = createFormData(data);
		// reset();
		createFair(formData);
	};

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);
	return <FairForm isLoading={isPending} onSubmit={handleCreateFair} />;
}
